import JtlApiClient from "./base";

export const plentyApi = {
  clean_up_bundles: () => {
    return JtlApiClient.post(`/plenty/clean-up-bundles`);
  },

  // Cron Job Management
  startCronJob: (schedule) => {
    return JtlApiClient.post("/plenty/cron/start", null, {
      params: {
        schedule,
      },
    });
  },

  stopCronJob: () => {
    return JtlApiClient.post("/plenty/cron/stop");
  },

  getCronStatus: () => {
    return JtlApiClient.get("/plenty/cron/status");
  },

  getSystemStatus: () => {
    return JtlApiClient.get("/plenty/system-status");
  },
};
